export default __webpack_public_path__ + "static/visa-a05453b4b203ed08557d7dcbd683adfb.png";